import type { ShipmentLineItem } from "~/shared/schemas/shipment-management-schema";

type LinearFeetCalculationItem = {
	commodity: string;
	length: number | null;
	width: number | null;
	height: number | null;
	quantity: number | null;
	weight: number | null;
	stackable: boolean;
};

export const toNumber = (value: string | number | null | undefined): number => {
	if (value == null || value === "") {
		return 0;
	}
	const parsed = Number(value);
	return Number.isNaN(parsed) ? 0 : parsed;
};

export const buildLinearFeetRequestBody = (
	lineItems: ShipmentLineItem[],
): LinearFeetCalculationItem[] =>
	lineItems
		.map((item) => ({
			commodity: item.commodityDescription ?? "",
			length: toNumber(item.length) || null,
			width: toNumber(item.width) || null,
			height: toNumber(item.height) || null,
			quantity: toNumber(item.handlingUnit) || null,
			weight: toNumber(item.totalWeight) || null,
			stackable: item.stackable ?? false,
		}))
		.filter(
			(item) =>
				(item.quantity ?? 0) > 0 &&
				(item.weight ?? 0) > 0 &&
				(item.length ?? 0) > 0 &&
				(item.width ?? 0) > 0 &&
				(item.height ?? 0) > 0,
		);
